import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=189f5328&"
import script from "./contents.vue?vue&type=script&lang=js&"
export * from "./contents.vue?vue&type=script&lang=js&"
import style0 from "./contents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports